import { render, staticRenderFns } from "./BoardFilter.vue?vue&type=template&id=dec7c8d2&"
import script from "./BoardFilter.vue?vue&type=script&lang=js&"
export * from "./BoardFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports